import { observer } from 'mobx-react';
import React from 'react';
import { promocodeStore } from '../../store/promocodeStore';
import { PROMOCODE_MENU } from '../../types/promocodes';
import { PRODUCT_TYPE } from 'src/types/product';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import {
  CATEGORY_MODAL_CATEGORY,
  CATEGORY_MODAL_PRODUCT,
  ICategoryOrProductItem,
} from 'src/view/containers/Modals/CategoryAndProductModal/CategoryAndProductModal';
// eslint-disable-next-line max-len
import CategoryAndProductModalOpen from 'src/view/containers/Modals/CategoryAndProductModal/components/CategoryAndProductModalOpen/CategoryAndProductModalOpen';
import Text from '~/view/components/Text/Text';

@observer
export default class PromocodeCategory extends React.Component<{}, {}> {
  changeMenu = (key: string | number) => {
    promocodeStore.changePromocode({ menu: key as PROMOCODE_MENU }, true);
  };

  selectCategoryAndProduct = (categories?: ICategoryOrProductItem[], products?: ICategoryOrProductItem[]) => {
    promocodeStore.changePromocode({ categories, products }, true);
  };

  get productInput() {
    return (
      promocodeStore.promocode.categories &&
      promocodeStore.promocode.categories.length > 0 &&
      promocodeStore.promocode.menu === PROMOCODE_MENU.INCLUDE
    );
  }

  get categoriesOptions(): IPickerOption[] {
    return [
      { value: PROMOCODE_MENU.ALL, label: 'all' },
      { value: PROMOCODE_MENU.EXCLUDE, label: 'excluded_categories' },
      { value: PROMOCODE_MENU.INCLUDE, label: 'included_categories' },
    ];
  }

  render() {
    return (
      <div className="mt-6">
        <Text type="block-header" text="categories" required />
        <div className="d-flex flex-row flex-wrap align-items-center">
          <TabPicker
            value={promocodeStore.promocode.menu || PROMOCODE_MENU.ALL}
            options={this.categoriesOptions}
            onChange={this.changeMenu}
            error={!promocodeStore.isValid.menu}
            className="mr-4 mt-2"
          />
          {promocodeStore.promocode.menu === PROMOCODE_MENU.ALL ? null : (
            <CategoryAndProductModalOpen
              selectedCategories={promocodeStore.promocode.categories}
              selectedProducts={promocodeStore.promocode.products}
              isCategories={CATEGORY_MODAL_CATEGORY.MULTIPLE}
              productTypes={[PRODUCT_TYPE.PRODUCT, PRODUCT_TYPE.MEAL_COMBO, PRODUCT_TYPE.DEAL_COMBO]}
              isProducts={promocodeStore.promocode.menu === PROMOCODE_MENU.EXCLUDE ? CATEGORY_MODAL_PRODUCT.NONE : CATEGORY_MODAL_PRODUCT.MULTIPLE}
              save={this.selectCategoryAndProduct}
              className="w-42 mt-2"
              categoryInputValid={(promocodeStore.promocode.categories?.length || 0) >= 1}
              productInput={this.productInput}
            />
          )}
        </div>
      </div>
    );
  }
}
